<template>
  <v-container fluid full-height grid-list-md>
    <v-layout row wrap>
      <v-flex xs6>
        <div class="text-xs-left">
          <v-breadcrumbs :items="breadcrumbs" divider=">"></v-breadcrumbs>
        </div>
      </v-flex>
      <v-flex xs6>
        <div class="text-xs-right">
          <v-btn color="primary" @click="onRegister">
            New Product Group
            <v-icon right>add_circle</v-icon>
          </v-btn>
          <v-btn color="primary" @click="openDialog=true">Import Product Group</v-btn>
        </div>
      </v-flex>
      <v-flex xs12>
        <v-card>
          <v-layout row wrap class="pa-3">
            <v-flex sm3>
              <v-text-field
                name="name"
                label="Product Group Name"
                type="text"
                v-model="queryParams.name"
              ></v-text-field>
            </v-flex>
            <v-flex sm3>
              <v-text-field
                name="code"
                label="Product Group Code"
                type="text"
                v-model="queryParams.code"
              ></v-text-field>
            </v-flex>
            <v-flex sm3>
              <v-select
                :items="statusList"
                label="Status"
                v-model="queryParams.status"
                item-text="label"
                item-value="value"
              ></v-select>
            </v-flex>
            <v-flex sm3>
              <v-btn outline color="primary" @click="onSearch">
                Search
                <v-icon right>search</v-icon>
              </v-btn>
            </v-flex>
            <v-flex sm3>
              <v-btn :loading="buttonLoading" color="success" @click="exportAllProductGroup()">EXPORT ALL</v-btn>
            </v-flex>
          </v-layout>
        </v-card>
      </v-flex>
      <v-flex xs12 class="mt-1">
        <v-card>
          <v-data-table
            :headers="headers"
            :items="productGroupList"
            class="elevation-1"
            :loading="showListLoading"
            :total-items="totalRows"
            :rows-per-page-items="rowsPerPageItems"
            :pagination.sync="pagination"
            must-sort
          >
            <template slot="items" slot-scope="props">
              <td>{{ props.item.name }}</td>
              <td>{{ props.item.code }}</td>
              <td>{{ props.item.description }}</td>
              <td>{{ props.item.updatedDateInMilliSeconds | format-ms-date-time }}</td>
              <td>{{ props.item.updatedBy }}</td>
              <td>
                <v-icon v-if="props.item.status=='ACTIVE'" medium color="green">check_circle</v-icon>
                <v-icon v-else medium color="red">cancel</v-icon>
              </td>
              <td>
                <v-btn flat icon color="blue lighten-2" @click="onEdit(props.item)">
                  <v-icon>edit</v-icon>
                </v-btn>
              </td>
            </template>
          </v-data-table>
        </v-card>
      </v-flex>
    </v-layout>
    <!-- dialog -->
    <productGroupExcel :isOpen="openDialog" v-on:change="dialogClose()"></productGroupExcel>
  </v-container>
</template>

<script>
import { productGroupService } from "../../services/product-group-service";
import productGroupExcel from "../../components/product-group/ProductGroupExcel";
import { commonService } from "../../services/common-service";

export default {
  name: "Product Group List",

  components: { productGroupExcel },
  data: () => ({
    showListLoading: false,
    buttonLoading: false,
    breadcrumbs: [
      {
        text: "General",
        disabled: true
      },
      {
        text: "Product Group",
        disabled: true
      }
    ],
    headers: [
      { text: "Name", align: "left", value: "name" },
      { text: "Code", value: "code" },
      { text: "Description", value: "description" },
      { text: "Updated  Date", value: "updatedDate" },
      { text: "Updated  By", value: "updatedBy" },
      { text: "Status", value: "status", sortable: false },
      { text: "Action", value: "name", sortable: false }
    ],
    rowsPerPageItems: [25, 50, 100],
    pagination: {
      descending: true,
      page: 1,
      rowsPerPage: 50,
      sortBy: "name",
      totalItems: 0
    },
    productGroupList: [],
    openDialog: false,
    totalRows: 0,
    statusList: [
      { label: "All", value: "" },
      { label: "Active", value: "ACTIVE" },
      { label: "Inactive", value: "INACTIVE" }
    ],
    queryParams: {
      name: "",
      code: "",
      status: "ACTIVE"
    }
  }),
  watch: {
    pagination: {
      handler() {
        this.getProductGroupList();
      },
      deep: true
    }
  },
  created() {
    //for deep linking
    if (this.$route.query.name) {
      this.queryParams.name = this.$route.query.name;
    }
    if (this.$route.query.code) {
      this.queryParams.code = this.$route.query.code;
    }
    if (this.$route.query.status) {
      this.queryParams.status = this.$route.query.status;
    }
    if (this.$route.query.page) {
      this.pagination.page = this.$route.query.page;
    }
    if (this.$route.query.size) {
      this.pagination.size = this.$route.query.size;
    }
  },
  methods: {
    onSearch() {
      this.queryParams.page = this.pagination.page;
      this.queryParams.size = this.pagination.rowsPerPage;
      this.$router.replace({ name: "product-groups", query: this.queryParams });
      this.getProductGroupList();
    },
    getProductGroupList() {
      this.showListLoading = true;
      let order = this.pagination.descending ? "desc" : "asc";
      productGroupService
        .getProductGroupList(
          this.queryParams,
          this.pagination.page,
          this.pagination.rowsPerPage,
          this.pagination.sortBy + "," + order
        )
        .then(res => {
          if (res.data) {
            this.productGroupList = res.data.productGroupList;
            this.totalRows = res.data.totalElements;
          }
        })
        .catch(err => {
          console.log(err);
        })
        .finally(() => {
          this.showListLoading = false;
        });
    },
    exportAllProductGroup() {
      this.buttonLoading = true;
      productGroupService
        .getProductGroupExcelExport(this.queryParams)
        .then(res => {
          commonService.downloadE(res);
        })
        .catch(err => {
          console.log(err);
        });
      this.buttonLoading = false;
    },
    dialogClose() {
      this.openDialog = false;
      this.getProductGroupList();
    },
    onRegister() {
      this.$router.push("/product-group/new");
    },
    onEdit(productGroup) {
      // go to details page
      this.$router.push("/product-group/" + productGroup.id);
    }
  }
};
</script>